import { render, staticRenderFns } from "./ArrayTable.vue?vue&type=template&id=5831fff6&scoped=true"
import script from "./ArrayTable.vue?vue&type=script&lang=js"
export * from "./ArrayTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5831fff6",
  null
  
)

export default component.exports